import { Link } from 'react-router-dom';
import { useCaseByIdQuery } from '@/queries/case';
import { getUnosId } from '@/utils/helpers';
import { Uuid } from '@/api/types';

export const LinkToCase = ({ id }: { id: Uuid }) => {
  const { data } = useCaseByIdQuery(id);
  if (!data) return null;

  const {
    donorId,
    organType,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    laterality,
    duplicateCaseNumber,
  } = data;

  return (
    <Link className="underline" to={`/case/${id}`}>
      {getUnosId(
        donorId,
        organType,
        reAllocationSequenceNumber,
        opoRequest,
        isExpeditedCase,
        laterality,
        duplicateCaseNumber,
      )}
    </Link>
  );
};
